import React from "react";
import { Sparkles, Zap, Droplet, Waves, Sun, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    id: "facial",
    name: "Signature Facial",
    tagline: "Radiance, rebalanced",
    icon: Droplet,
    description:
      "Custom facial treatments tailored to your skin's needs — cleansing, exfoliation, extractions, and targeted serums for a luminous, healthy glow.",
    benefits: [
      "Deep cleansing & exfoliation",
      "Hydration & barrier repair",
      "Pore refinement",
      "Immediate radiance"
    ]
  },
  {
    id: "laser-hair-removal",
    name: "Laser Hair Removal",
    tagline: "Smooth, forever soft",
    icon: Zap,
    description:
      "Long-lasting laser hair reduction for face and body. Safe, fast, and effective treatments calibrated to your skin tone for beautifully smooth, maintenance-free skin.",
    benefits: [
      "All skin-tone safe technology",
      "Minimal discomfort",
      "Face & body areas",
      "Long-term reduction"
    ]
  },
  {
    id: "skinpen",
    name: "SkinPen Microneedling",
    tagline: "Rebuild from within",
    icon: Sparkles,
    description:
      "The first FDA-cleared microneedling device. Triggers your skin's natural regeneration to smooth fine lines, acne scars, and texture for renewed, youthful skin.",
    benefits: [
      "Fine lines & wrinkles",
      "Acne scar revision",
      "Texture & pore size",
      "Natural collagen boost"
    ]
  },
  {
    id: "genius-rf",
    name: "Genius RF Microneedling",
    tagline: "Precision tightening",
    icon: Waves,
    description:
      "Advanced radiofrequency microneedling by Lutronic. Real-time energy delivery tightens skin, sculpts contours, and remodels collagen from the inside out.",
    benefits: [
      "Skin tightening",
      "Jawline & contour definition",
      "Scar revision",
      "Minimal downtime"
    ]
  },
  {
    id: "lasemd-ultra",
    name: "LaseMD Ultra",
    tagline: "Glow, unlocked",
    icon: Sun,
    description:
      "Non-ablative fractional laser that resurfaces skin with minimal downtime. Targets tone, texture, and pigmentation while infusing custom Cosmeceutical cocktails for a radiant finish.",
    benefits: [
      "Pigmentation & sun damage",
      "Tone & texture refinement",
      "Brightening & glow",
      "Lunch-break recovery"
    ]
  }
];

const ServicesSection = () => {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="services"
      className="section-padding services-section"
      data-testid="services-section"
    >
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">Aesthetic Services</h2>
          <p className="body-large section-subtitle">
            Over a decade of expertise in aesthetics — medical-grade treatments delivered with island warmth and an artist's touch.
          </p>
        </div>

        <div className="services-grid" data-testid="services-grid">
          {SERVICES.map((service) => {
            const Icon = service.icon;
            return (
              <article
                key={service.id}
                id={`service-${service.id}`}
                className="service-card"
                data-testid={`service-card-${service.id}`}
                itemScope
                itemType="https://schema.org/Service"
              >
                <div className="service-icon-wrap">
                  <Icon size={28} strokeWidth={1.4} />
                </div>

                <div className="service-body">
                  <h3 className="service-name" itemProp="name">{service.name}</h3>
                  <p className="service-tagline">{service.tagline}</p>
                  <p className="service-description body-regular" itemProp="description">
                    {service.description}
                  </p>

                  <ul className="service-benefits">
                    {service.benefits.map((b) => (
                      <li key={b} className="service-benefit">
                        <span className="service-benefit-dot" aria-hidden="true" />
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>

                <button
                  type="button"
                  onClick={scrollToContact}
                  className="service-cta"
                  data-testid={`service-book-${service.id}`}
                  aria-label={`Book a ${service.name} consultation`}
                >
                  Book a Consultation
                  <ArrowRight size={16} aria-hidden="true" />
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
